var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.00977L21.5 3.00977C21.7652 3.00977 22.0196 3.11512 22.2071 3.30266C22.3946 3.4902 22.5 3.74455 22.5 4.00977L22.5 20.0098C22.5 20.275 22.3946 20.5293 22.2071 20.7169C22.0196 20.9044 21.7652 21.0098 21.5 21.0098L3.5 21.0098C3.23478 21.0098 2.98043 20.9044 2.79289 20.7169C2.60536 20.5293 2.5 20.275 2.5 20.0098L2.5 4.00977C2.5 3.74455 2.60536 3.4902 2.79289 3.30266C2.98043 3.11512 3.23478 3.00977 3.5 3.00977ZM20.5 7.24777L12.572 14.3478L4.5 7.22577L4.5 19.0098L20.5 19.0098L20.5 7.24777ZM5.011 5.00977L12.561 11.6718L20.002 5.00977L5.011 5.00977Z",
    fill: "#1C9FDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a9225a47a1c35b2ff0777ce7e49efc2f.svg";
export { ForwardRef as ReactComponent };